<spinner *ngIf="loading"></spinner>

<h4 class="pb-3">Draft patients <i class="bi bi-caret-right-fill"></i></h4>

<ngx-datatable
    class="bootstrap mt-4"
    #table
    [rows]="rows"
    [columnMode]="'flex'"
    [headerHeight]="50"
    [externalPaging]="true"
    [footerHeight]="30"
    [rowHeight]="'auto'"
    [limit]="pagination.size"
    [count]="pagination.totalCount"
    [offset]="pagination.start"
    (page)="setPage($event)"
    [messages]="{emptyMessage: 'No draft patients found', totalMessage: 'records found'}"
>
    <ngx-datatable-column name="First name" [sortable]="false" [flexGrow]="1">
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ getTypeLabel(row) == 'Carer only' ? row.carer.user.firstName : row.user.firstName }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Last name" [sortable]="false" [flexGrow]="1">
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ getTypeLabel(row) == 'Carer only' ? row.carer.user.lastName : row.user.lastName }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Type" [sortable]="false" [flexGrow]="1">
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ getTypeLabel(row) }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Feature Set" [sortable]="false" [flexGrow]="1">
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ getFeatureSetLabel(row) }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Actions" [sortable]="false" [flexGrow]="0" [minWidth]="90" cellClass="text-end">
        <ng-template let-row="row" ngx-datatable-cell-template>

            <a [routerLink]="['/cdss/patient-registration', row.id]" class="btn btn-sm rounded-pill btn-success px-2" style="line-height:12px">&gt;</a>

        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>
